import React from "react";
import { useTranslation } from "react-i18next";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { InternalToolContainer } from "../../components/InternalTools/InternalToolsContainer";
import { InternalToolsContextProvider } from "../../components/InternalTools/InternalToolsContextProvider";
import InternalToolsSelect from "../../components/InternalTools/InternalToolsSelect";

import "./styles.scss";

type IInternalToolsPageProps = RouteComponentProps<any>;

const InternalToolsPage: React.FunctionComponent<
  IInternalToolsPageProps
> = () => {
  const { t } = useTranslation();

  return (
    <InternalToolsContextProvider>
      <div className="right-content internal-tool">
        <div className="top-title-bar flex-grid">
          <PageTitle text={"Internal Tools"} />
          <div className="line"></div>
        </div>

        <Link className="new-page-link" to="/admin/internalTools">
          {t("internalToolsPage.new_page_link")}
        </Link>

        <div className="internal-tools-header">
          <InternalToolsSelect />
        </div>
        <InternalToolContainer />
      </div>
    </InternalToolsContextProvider>
  );
};

export default withRouter(InternalToolsPage);
